import { useEffect } from "react";

import { useQuery } from "@tanstack/react-query";

import { MatomoConsentBanner } from "@/components/common/MatomoConsentBanner";
import { currentUserQueryOptions } from "@/lib/queries/current-user";
import { setMatomoUserId } from "@/lib/matomo/tracker";

/** Keeps Matomo User ID in sync with session email (`DbUser.email` ↔ reader `usr_email`). */
export function MatomoSessionBridge() {
  const { data: user } = useQuery({
    ...currentUserQueryOptions(),
    retry: false,
    throwOnError: false,
  });

  useEffect(() => {
    setMatomoUserId(user?.email ?? null);
  }, [user?.email]);

  return <MatomoConsentBanner />;
}
